import React from 'react';
import PropTypes from 'prop-types';

import { useSelector } from 'react-redux';

import injectSheet from 'react-jss';

import { getTeamFromPick } from '../../../redux/features/picks/picks';

const styles = {
  winner: {
    // position: 'absolute',
    // marginTop: '-90px',
    fontFamily: 'Roboto',
    minHeight: '140px',
    '& a': {
      cursor: 'pointer',
    },
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    // marginBottom: '240px',
  },
  img: {
    width: '60px',
  },
  win: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    // marginTop: '90px',
  },
  name: {
    textTransform: 'uppercase',
    fontWeight: '400',
    fontSize: '20px',
    // marginBottom: '20px',
  },
  bold: {
    fontWeight: '700',
  },
  stars: {
    margin: '5px 0',
    maxHeight: '15px',
  },
  share: {
    position: 'fixed',
    width: '100%',
    bottom: '0',
    left: '0',
    fontFamily: 'Roboto',
    backgroundColor: '#f4f5f0',
  },
  sharecontent: {
    padding: '20px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: '1px solid #ccc',
    borderRadius: '5px',
    margin: '0 auto',
  },
  item: {
    padding: '0 10px',
    display: 'flex',
    alignItems: 'center',
  },
  socialicons: {
    display: 'flex',
    alignItems: 'center',
    // marginTop: '10px',
  },
  socialicon: {
    height: '20px',
    padding: '0 5px',
  },
  login: {
    border: '0',
    cursor: 'pointer',
  },
};

const Winner = ({ classes, id }) => {
  const team = useSelector((state) => getTeamFromPick(state, id));

  return (
    <div className={classes.winner}>
      <div className={classes.container}>
        <div className={classes.win}>
          {!!team.name && (
            <div>
              <img className={classes.img} src={`assets/images/flags/${team.id}.svg`} alt={team.name} />
              <br />
              <img
                className={classes.stars}
                src={`assets/images/wc_stars/${1 + Number(team.wc)}.svg`}
                alt={`${team.name} ${1 + Number(team.wc)}`}
              />
              <div className={classes.name}>
                <div className={classes.bold}>{team.name}</div>
                <div>WORLD CHAMPIONS!</div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

Winner.propTypes = {
  classes: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
};

export default injectSheet(styles)(Winner);
